import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  border-radius: 10px;
  padding: 0px 5px;
  .buyer-skeleton-wrapper{
    margin-top: 7px;
    display: flex;
    width: 100%;
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0px 0px 9px rgb(0 0 0 / 10%);
    padding: 10px 15px;
    margin-bottom: 7px;
    > div{
      width:100%;
    }
    .company-logo{
      height: 50px;
      width:50px;
      border-radius:50%;
      align-self: center;
    }
    .details {
      padding-left: 15px;
      display:flex;
      flex-direction:column;
      .title-box {
        height: 16px;
        border-radius: 20px;
        width: 180px;
        margin-bottom:5px;
      }
      .title-box-short{
        height: 14px;
        border-radius: 20px;
        width: 130px;
        margin-bottom:7px;
      }
      .title-box-short-1{
        height: 12px;
        border-radius: 20px;
        width: 100px;
        margin-bottom:0px;
      }
    }
    .btn{
        height: 25px;
        border-radius: 25px;
        width: 60px;
        margin-bottom:0px;
    }
  }
  .skeleton-box {
    height: 20px;
    border-radius: 25px;
    width: 50px;
  }
`;

const PeopleCardListSkeleton = function PeopleCardListSkeleton() {
  return (
    <Wrapper className='people-list-view-new-class'>
      <div className="buyer-skeleton-wrapper">
        <div className="d-flex justify-content-center align-self-center justify-content-between">
          <div className="left-profile d-flex justify-content-center align-self-center">
            <span className="skeleton-box company-logo" />
            <div className="details">
              <span className="skeleton-box title-box" />
              <span className="skeleton-box title-box-short" />
              <span className="skeleton-box title-box-short-1" />
            </div>
          </div>
          <div className="d-flex justify-content-center align-self-center">
            {/* <span className="skeleton-box btn" /> */}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default PeopleCardListSkeleton;
